import { Instance } from 'mobx-state-tree';
import { CustomerNotificationsSummaryDtoModelBase } from './CustomerNotificationsSummaryDtoModel.base';

/* The TypeScript type of an instance of CustomerNotificationsSummaryDtoModel */
export interface CustomerNotificationsSummaryDtoModelType extends Instance<typeof CustomerNotificationsSummaryDtoModel.Type> {}

/* A graphql query fragment builders for CustomerNotificationsSummaryDtoModel */
export { selectFromCustomerNotificationsSummaryDto, customerNotificationsSummaryDtoModelPrimitives, CustomerNotificationsSummaryDtoModelSelector } from './CustomerNotificationsSummaryDtoModel.base';

/**
 * CustomerNotificationsSummaryDtoModel
 */
export const CustomerNotificationsSummaryDtoModel = CustomerNotificationsSummaryDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
